import type { DecorationScreenSchema } from "./types";

export const keyboardSchema = {
	keyboard: { css: [], variant: { values: ["panel"], default: null } },
} as const satisfies DecorationScreenSchema;
